import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM, typesApex } from '../../../components/models';
import { TranslateService } from '@ngx-translate/core';
import { formatear } from '../../funciones/funcionesGenerales';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import Swal from 'sweetalert2';
import { GraficasComponent } from '../../../components/graficas/graficas.component';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
// Registrar fuentes virtuales
pdfMake.addVirtualFileSystem(pdfFonts);
import { generatePDF } from '../../funciones/makePdf';

@Component({
  selector: 'app-tendencia',
  templateUrl: './tendencia.component.html',
  styleUrl: './tendencia.component.css'
})
export class TendenciaComponent implements OnInit{
  @ViewChildren(GraficasComponent) grafComp!: QueryList<GraficasComponent>;
  private pdfFile: any;
  
  types = typesApex;
  maxPeriods = 12;
  subtitles1 = '';
  subtitles2 = '';
  // Valores para generar la gráfica 1
  tituloZona1 = '';
  data1 = [];
  labels1 = [];
  axisY1 = [];
  reset1 = false;
  graphics1 = [typesApex.AREA, typesApex.BAR, typesApex.COMBO, typesApex.LINE, typesApex.TABLE];
  zona1 = 1;
  //
  data2 = [];
  //
  perspectives = [];
  tituloZona2 = 'Sucursales';
  //
  productos = ['Ordinario', 'Promedio', 'A la vista']
  DPF = [90, 180, 270, 360];
  // Variables Filtros
  Filters = FiltersM;
  yearsAvailable = [];
  monthAvailable = [];
  monthSelect = false;

  sucursales = [];
  consolidado = true;

  periodicidad = [
    {name: 'Mensual', check: true, value: 1},
    {name: 'Bimestral', check: false, value: 2},
    {name: 'Semestral', check: false, value: 6},
    {name: 'Anual', check: false, value: 12},
  ];
  
  Tarjets = [
    1,
    1,
    1,
    1
  ]
  
  constructor(
    public dataService: DataService,
    public translate: TranslateService,
  ) {}

  ngOnInit(){
    formatear.momentAbrev();
    this.getPeriods();
  }

  private getPeriods(){
    for(var i = 0; i<10; i++){
      this.sucursales.push({
        name: `Sucursal-${i+1}`,
        check: false
      });
    }
    const start = moment('2023-01-01');
    const end = moment();
    var auxYear = [], auxMounts = [], year = undefined;
    while(start.isSameOrBefore(end)){
      const exYear = auxYear.find(y => y.anio === start.year());
      if(!exYear){
        year = start.year();
        auxYear.push({
          anio: start.year(),
          name: start.year()+'',
          check: false,
          visible: true,
          utilizable: true,
        });
      }
      auxMounts.push({
        mes: start.format('MMM').toLowerCase(),
        mesS: start.format('MMMM').toLowerCase(),
        check: false,
        an: start.year(),
        anio: start.format('YY'),
        periodo: start.format('MMM-YY').toLowerCase(),
        visible: true,
        utilizable: true,
      });
      start.add(1, 'month');
    }

    this.monthAvailable = auxMounts;
    this.yearsAvailable = auxYear;
    this.yearsAvailable[this.yearsAvailable.length-1].check = true;

    this.tituloZona1 = 'Consolidado';
    this.getData();
  }
  //Consultas para obtener información
  private getData(){
    this.data1 = [];
    this.labels1 = [];
    this.axisY1 = [];
    var auxData1Series1 = [], auxData1Series2 = [];
    var pos = 0;
    const peri = this.periodicidad.find(el => el.check === true);
    var yearSelect = this.yearsAvailable.find(y => y.check === true);
    [...this.monthAvailable].reverse().forEach(mes =>{
      if( (mes.an === yearSelect.anio && auxData1Series1.length === 0) || ( auxData1Series1.length > 0 && auxData1Series1.length < this.maxPeriods && pos%peri.value === 0)){
        var max = 15, min = 5;
        var max2 = 1.5, min2 = 0.5;
        auxData1Series1.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(1)) );
        auxData1Series2.push( Number(( Math.random()* (max2 - min2 + 1) + min2 ).toFixed(1)) );

        this.labels1.push(mes.periodo);
      }
      if(auxData1Series1.length !== 0){
        pos++;
      }
    });

    this.labels1.reverse();

    this.data1.push({
      name: 'serie-1',
      type: typesApex.BAR,
      data: auxData1Series1.reverse()
    },{
      name: 'serie-2',
      type: typesApex.LINE,
      data: auxData1Series2.reverse()
    });
    this.axisY1.push('serie-1', 'serie-2');
    
    //Data 2
    this.data2 = [];
    for(var i = 0; i<this.sucursales.length; i++){
      this.data2.push({
        sucursal: `S-${i+1}`,
      });
      for(const p of this.productos){
        var max = 2000000, min = 400000;
        this.data2[i][p] =  Number(( Math.random()* (max - min + 1) + min ).toFixed(0));
      }
      for(const d of this.DPF){
        var max = 30000, min = 2000;
        this.data2[i][d] =  Number(( Math.random()* (max - min + 1) + min ).toFixed(0));
      }
    }
    this.generateSubtitles();
  }

  private async generateSubtitles(){
    this.subtitles1 = '';
    this.subtitles2 = '';
    var pos = 0;
    var labels = 0;
    const peri = this.periodicidad.find(el => el.check === true);
    var yearSelect = this.yearsAvailable.find(y => y.check === true);
    var monthSelect = this.monthAvailable.find(m => m.check === true);
    if(!monthSelect){
      [...this.monthAvailable].reverse().forEach(mes =>{
        const an = this.subtitles1.split(' | ');
        const ex = an.find( a => Number(a) === Number((mes.an+'').substring(2,4)) );
        if( !ex && (mes.an === yearSelect.anio || (pos%peri.value === 0 && labels < this.maxPeriods)) ){
          this.subtitles1 += `${(mes.an+'').substring(2,4)} | `;
          labels++;
        }
        if(labels !== 0){
          pos++;
        }
      });

      this.subtitles2 = '';
      this.subtitles2 = yearSelect.name.substring(2,4);
      this.subtitles1 = this.subtitles1.substring(0, this.subtitles1.length-3);
    }else{
      this.subtitles1 = monthSelect.periodo;
      this.subtitles2 = monthSelect.periodo;
    }
    if(this.consolidado){
      const traduccion = await firstValueFrom(
        this.translate.get('filtros.consolidado')
      );
      this.subtitles1 += ` | ${traduccion}`;
      this.subtitles2 += ` | ${traduccion}`;
    }else{
      for(const suc of this.sucursales){
        if(suc.check){
          this.subtitles1 += ` | ${suc.name}`;
          this.subtitles2 += ` | ${suc.name}`;
        }
      }
    }
  }

  public formaters(data, tipo){
    switch(tipo){
      case 'decimales':
        return formatear.formatearMoneda(data, true, ',', '.')
      case 'enteros':
        return formatear.formatearMoneda(data, false, ',', '.')
    }
  }

  clickGraphicPrincipal(event){
    if(this.perspectives.length === 0){
      for(var i=0; i<8; i++){
        this.perspectives.push({
          name: `Perspective ${i+1}`,
          id: i
        });
      }
    }
    this.monthAvailable.forEach( m =>{
      if(m.periodo === event.name){
        m.check = true;
      }else{
        m.check = false;
      }
    });
    this.monthSelect = true;
    this.generateSubtitles(); 
  }
  periodicityChange(event: any) {
    this.periodicidad.forEach( p => {
      if(p.value === event.value){
        p.check = true;
      }else{
        p.check = false;
      }
    });
    this.getData();
  }
  yearChange(year: object): void {
    this.yearsAvailable.forEach( y => {
      if(year['name'] === y.name){
        y.check = true;
      }else{
        y.check = false;
      }
    });
    this.getData();
  }
  sucursalChange(sucClick){
    for(const suc of this.sucursales){
      if(sucClick !== 'consolidado' && suc.name === sucClick.name){
        suc.check = true;
      }else{
        suc.check = false;
      }
    }
    if(sucClick === 'consolidado'){
      this.consolidado = !this.consolidado;
    }else{
      this.consolidado = false;
    }
    this.getData();
  }
  // Reset filters
  public resetFilters(){
    this.reset1 = true;
    setTimeout(() =>{
      this.reset1 = false;
    },10);

    this.monthSelect = false;

    for(const month of this.monthAvailable){
      month.check = false;
    }

    for(const suc of this.sucursales){
      suc.check = false;
    }
    this.consolidado = true;

    for(const per of this.periodicidad){
      per.name.toLowerCase() === 'mensual' ? per.check = true: per.check = false;
    }
    for(const an of this.yearsAvailable){
      if (an === this.yearsAvailable[this.yearsAvailable.length - 1]) {
        an.check = true;
      }else{
        an.check = false;
      }
    }

    this.getData();
  }
  //Exportaciones
  exportarSucursales(){
    
  }
  //Exportación de PDF All
  async exportarPDF(){
    try{
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))

      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;

      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        content: [
          await this.generateZonaPDF(this.zona1),
          await this.generateTablePDF(),
        ]
      }

      var reportName = 'Reporte general';
      const pdf = pdfMake.createPdf(docPDF);
      
      pdf.download(reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;

      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
    }catch(error){
      Swal.close();
      Swal.fire({title: this.translate.instant('cues.reporte.errorReporte'), timer: 10000});
    }
  }
  private async generateZonaPDF(zonaE){
    const comp = this.grafComp.find(g => g.zona === zonaE);
    var img = undefined;
    var table = undefined;
    if(comp.type !== typesApex.TABLE){
      img = await comp.exportImgBlob();
    }
    table = await comp.exportTablePDF();

    var cont = [
      comp.exportTitles(),
      // table !== undefined ? {
      //   text: 'Tabla'
      // } : { text: '' },
      table !== undefined ? table : { text: '' },
      // img !== undefined ? {
      //   text: 'Gráfica'
      // } : { text: '' },
      img !== undefined ? img : { text: '' }
    ];
    return cont;
  }
  private async generateTablePDF(){
    var headers = [];
    
    const h1 = [
      {text: '', col: 1},
      {text: this.translate.instant('comercial.captacion.tendencia.titulo-encabezado-1-1'), col: 3},
      {text: this.translate.instant('comercial.captacion.tendencia.titulo-encabezado-1-2'), col: 4},
    ];
    const h2 = [
      {text: this.translate.instant('comercial.captacion.tendencia.titulo-encabezado-2-1'), col: 1},
      ...this.productos.flatMap( e => { return { text: e, col:1 } }),
      ...this.DPF.flatMap( e => { return { text: e, col:1 } }),
    ];

    var data = [];
    headers.push(h1, h2)

    for(const d of this.data2){
      var aux = [];
      aux.push({text: d.sucursal});
      aux.push(...this.productos.map(e => {return {
        text: this.formaters(d[e], 'decimales'),
      }}));
      aux.push(...this.DPF.map(e => {return {text: this.formaters(d[e], 'decimales')} }));
      data.push(aux);
    }

    const head = await generatePDF.titles(this.tituloZona1, this.subtitles2);
    const tab = await generatePDF.table(headers, data);
    return [
      head,
      tab
    ];
  }
}
